<template>
    <div>
        <el-row class="cnt-wrapper">
            <el-col :span="4">
                <div class="dept-side">
                    <el-row class="dept-side-hd">
                        <el-col :span="12">职位</el-col>
                        <el-col :span="12" class="dept-side-edit"><a @click="handleCreate">新建职位</a></el-col>
                    </el-row>
                    <el-table ref="areaTable" highlight-current-row v-loading="loading" :data="roles" style="width: 100%" @row-click="handleClickRole" height="750">
                        <el-table-column prop="name"></el-table-column>
                        <el-table-column width="40">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="'复制（' + scope.row.name + '）权限'" placement="top-start">
                                    <i class="el-icon-copy-document" @click="handleCopy(scope.row)"></i>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- <el-menu
                            default-active="0"
                            class="el-menu-vertical-demo dept-menu-list">
                        <el-menu-item v-for="(role, key) in roles" :key="key" :index="key.toString()"
                                      @click="handleClickRole(role)"><i class="el-icon-arrow-right"></i>{{role.name}}
                        </el-menu-item>
                    </el-menu> -->
                </div>
            </el-col>
            <el-col :span="20">
                <div class="staff-main-content" style="border:1px solid #dcdcdc" v-loading="loading">
                    <el-row class="staff-main-title clearfix">
                        <div class="common-power" v-if="currentRole.name">{{currentRole.name}}的权限</div>
                        <div class="staff-view">
                            <el-button type="primary">查看权限</el-button>
                        </div>
                        <div class="high-power">
                            <a>
                                <el-dropdown trigger="click">
                                    <span class="el-dropdown-link">
                                        <i class="el-icon-setting"></i> 操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="handleUpdate(currentRole)">编辑
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native="handleDelete(currentRole)">删除
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </a>
                        </div>
                    </el-row>
                    <div>
                        <div class="staff-section">
                            <el-row class="staff-main-tips">
                                <el-col>数据查看<span></span></el-col>
                            </el-row>
                            <div class="staff-main-item">
                                <el-row>
                                    <label class="item-title">查看数据范围：</label>
                                    <el-select v-model="currentRole.allow_range" placeholder="请选择许可范围">
                                        <el-option
                                                v-for="range in allowRanges" :key="range.value"
                                                :value="range.value"
                                                :label="range.label"
                                        >
                                        </el-option>
                                    </el-select>
                                    <div class="dept-all-list" v-show="isShowBranches && branchesTree.length > 0">
                                        <el-tree
                                                empty-text="暂无数据"
                                                :data="branchesTree"
                                                show-checkbox
                                                ref="branchTree"
                                                node-key="id"
                                                default-expand-all
                                                :props="defaultProps">
                                        </el-tree>
                                    </div>
                                </el-row>
                            </div>
                        </div>
                        <div class="staff-section" v-if="permissions.length > 0" v-for="item in permissions"
                             :key="item.id">
                            <el-row class="staff-main-tips">
                                <el-col>{{item.module_name}}</el-col>
                            </el-row>
                            <div class="staff-main-item" v-if="item.options">
                                <el-row class="staff-main-item-link1 product-use">
                                    <el-checkbox
                                            v-for="option in item.options"
                                            :label="option.id"
                                            :key="option.id"
                                            v-model="currentRole.permissions"
                                    >
                                        {{option.name}}
                                    </el-checkbox>
                                </el-row>
                            </div>
                            <div class="staff-main-item capacity-item" v-if="item.module == 'rbac'">
                                <el-row class="capacity-setting">
                                    <label class="item-title">绑定客户上限：</label>
                                    <el-input-number
                                            v-model="currentRole.max_customer_limit"
                                            :min="0"
                                            :precision="0"
                                            :controls="false"
                                            placeholder="0 表示不限制">
                                    </el-input-number>
                                    <span class="capacity-tip">0 表示不限制</span>
                                    <label class="item-title vip-title">A类客户上限：</label>
                                    <el-input-number
                                            v-model="currentRole.max_vip_limit"
                                            :min="0"
                                            :precision="0"
                                            :controls="false"
                                            placeholder="0 表示不限制">
                                    </el-input-number>
                                    <span class="capacity-tip">0 表示不限制</span>
                                </el-row>
                            </div>
                        </div>
                    </div>
                    <el-row class="staff-main-tips staff-main-btn">
                        <el-button type="primary" size="small" @click="handleAuthorization">保存授权</el-button>
                    </el-row>
                </div>
            </el-col>
        </el-row>

        <el-dialog :title="formTitle" :visible.sync="showForm" :before-close="handleClose">
            <el-form :model="form" ref="form" :rules="rules">

                <el-form-item label="角色名称" prop="name" :label-width="formLabelWidth">
                    <el-input v-model="form.name" placeholder="请输入权限名称"></el-input>
                </el-form-item>

                <el-form-item label="备注" prop="memo" :label-width="formLabelWidth">
                    <el-input type="textarea" :rows="5" v-model="form.memo" auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button :loading="submiting" type="primary" @click="handleSave">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import {RoleModel, RoleService, ALLOW_BRANCHES} from "~/services/Role";
    import {BranchService} from "~/services/Branch";
    import {PermissionService} from "~/services/Permission";

    export default {
        data() {
            return {
                title: "职位管理",
                roles: [],
                showForm: false,
                formTitle: "",
                allowRanges: [],
                isShowBranches: false,
                form: {},
                rules: {
                    name: [
                        {
                            required: true,
                            message: "请输入职位名称名称"
                        },
                        {
                            type: "string",
                            max: 255,
                            message: "长度不能超过255个字符"
                        }
                    ],
                    allow_range: [
                        {
                            required: true,
                            message: "请选择允许查看范围"
                        }
                    ]
                },
                formLabelWidth: "120px",
                submiting: false,
                currentRole: {}, // 当前被点击选中的角色
                // 部门树结构数据
                branchesTree: [],
                defaultProps: {
                    children: 'childs',
                    label: 'name'
                },
                permissions: [],
                loading: true
            }
        },
        created: function () {
            // 初始化所有角色
            this.getRoles();

            // 初始化查看数据范围Select组件
            if (this.allowRanges.length < 1) {
                this.allowRanges = RoleService.getAllowRangeOptions();
            }

            // 初始化部门树结构数据
            if (this.branchesTree.length < 1) {
                this.getBranchesTree();
            }

            // 初始化权限选项数据
            if (this.permissions.length < 1) {
                this.getPermissionOptions();
            }
        },
        watch: {
            "currentRole.allow_range": function (value, original) {
                if (value == ALLOW_BRANCHES) {
                    this.isShowBranches = true;
                } else {
                    this.isShowBranches = false;
                }
            }
        },
        methods: {

            // 处理关闭对话窗口事件
            handleClose() {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？")
                    .then(_ => {
                        this.closeForm();
                    })
                    .catch(_ => {
                    });
            },

            closeForm() {
                this.showForm = false;
                // 强制清空表单
                this.$refs["form"].resetFields();
            },

            getRoles() {
                this.loading = true;
                RoleService.getList().then(res => {
                    this.loading = false;
                    if (res && res.code == 0) {
                        this.roles = res.data.map(role => this.normalizeRole(role));
                        // 初始化每次都默认选中角色列表的第一条数据
                        if (this.roles.length > 0 && !this.currentRole.id) {
                            this.currentRole = JSON.parse(JSON.stringify(this.roles[0]))
                        }
                    }
                }).catch(err => {
                    console.error(err);
                })
            },

            handleCreate() {
                this.formTitle = "创建角色";
                this.form = Object.assign({}, RoleModel);
                this.showForm = true;
            },

            handleSave() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.submiting = true;
                        if (this.form.id && this.form.id > 0) {
                            RoleService.update(this.form).then(res => {
                                this.submiting = false;
                                if (res && res.code == 0) {

                                    this.$message({
                                        type: "success",
                                        message: "更新成功!"
                                    });

                                    this.getRoles();
                                    this.closeForm();
                                }
                            }).catch((err) => {
                                console.error(err);
                                this.submiting = false;
                            });
                            return;
                        } else {
                            RoleService.create(this.form).then(res => {
                                this.submiting = false;
                                if (res && res.code == 0) {
                                    this.$message({type: "success", message: "创建成功!"});
                                    this.getRoles();
                                    this.closeForm();
                                }
                            }).catch((err) => {
                                console.error(err);
                                this.submiting = false;
                            });
                            return;
                        }

                    }
                });
            },

            handleClickRole(role) {
                if (parseInt(role.allow_range) == 0) {
                    role.allow_range = '';
                }

                this.currentRole = this.normalizeRole(JSON.parse(JSON.stringify(role)));
                if (this.currentRole.allow_branches && this.currentRole.allow_range == ALLOW_BRANCHES) {
                    let data = [];
                    this.currentRole.allow_branches.forEach(function (val, key) {
                        data.push(val);
                    })

                    this.$refs.branchTree.setCheckedKeys(data);
                }

                this.$forceUpdate();
            },

            /**
             * 得到部门树结构数据
             */
            getBranchesTree() {
                BranchService.getTreeStructure().then(res => {
                    if (res.code == 0 && res.data) {
                        var data = [];
                        res.data.forEach(function (val, key) {
                            if (val.id > 0) {
                                data.push(val);
                            }
                        });
                        this.branchesTree = JSON.parse(JSON.stringify(data));
                    }
                });
            },

            getPermissionOptions() {
                PermissionService.getOptions().then(res => {
                    if (res.code == 0 && res.data) {
                        this.permissions = res.data;
                    }
                })
            },

            handleUpdate(role) {
                if (!role.id) {
                    this.$message.error('请先选择要编辑的职位');
                    return;
                }

                this.form = Object.assign({}, {
                    id: role.id,
                    name: role.name,
                    memo: role.memo
                });

                this.formTitle = "编辑职位";
                // 显示编辑窗口
                this.showForm = true;
            },

            handleDelete(role) {
                if (!role.id) {
                    this.$message.error('请先选择要删除的职位');
                    return;
                }

                this.$confirm("确定要删除该职位?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    RoleService.delete(role.id).then(res => {
                        if (res.code == 0) {
                            this.getRoles();
                        }
                    })
                })
            },

            handleAuthorization() {
                this.currentRole.max_customer_limit = parseInt(this.currentRole.max_customer_limit) || 0;
                this.currentRole.max_vip_limit = parseInt(this.currentRole.max_vip_limit) || 0;
                if (this.currentRole.max_customer_limit < 0 || this.currentRole.max_vip_limit < 0) {
                    this.$message.error('库容上限不能小于 0');
                    return;
                }

                // 如果当前职位允许查看数据范围是指定部门的，就必须要选择一个树节点
                if (this.currentRole.allow_range == ALLOW_BRANCHES) {
                    let checkedBranches = this.$refs.branchTree.getCheckedNodes();
                    if (checkedBranches.length > 0) {
                        let branches = [];
                        checkedBranches.forEach(function (value, key) {
                            branches[key] = value.id;
                        })
                        this.currentRole.allow_branches = branches;
                    }
                }

                if (
                    this.currentRole.allow_range == ALLOW_BRANCHES
                    && this.currentRole.allow_branches.length < 1) {
                    this.$message.error('请至少选择一个部门');
                    return;
                }

                RoleService.authorization(this.currentRole).then(res => {
                    if (res.code == 0 && res.data) {

                        this.$message({
                            type: "success",
                            message: "保存授权成功",
                            // onClose: function () {
                            //     location.reload()
                            // }
                        });

                        this.currentRole = this.normalizeRole(res.data);
                        this.getRoles();
                    }
                })
            },
            
            handleCopy(row){
                this.formTitle = '复制（' + row.name + '）权限';
                this.form = Object.assign({}, RoleModel);
                this.form.permissions = row.permissions;
                this.form.allow_range = row.allow_range;
                this.form.allow_branches = row.allow_branches;
                this.form.max_customer_limit = parseInt(row.max_customer_limit) || 0;
                this.form.max_vip_limit = parseInt(row.max_vip_limit) || 0;
                this.showForm = true;
                console.log('handleCopy', this.form, row);
            },

            normalizeRole(role) {
                role.max_customer_limit = parseInt(role.max_customer_limit) || 0;
                role.max_vip_limit = parseInt(role.max_vip_limit) || 0;
                return role;
            }
        }
    }
</script>

<style scoped>
    .capacity-setting {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .capacity-setting .el-input-number {
        width: 160px;
    }

    .capacity-tip {
        margin-left: 8px;
        color: #909399;
    }

    .vip-title {
        margin-left: 28px;
    }
</style>



// WEBPACK FOOTER //
// src/views/roles/index.vue